import React from 'react';
import { connect } from 'react-redux';

//Components
import SmartMenu from '../index';
import WpBadge from 'Wpds/components/badge/WpBadge';
import { SmartLinkLogo } from '../../components';
import { WpButton } from 'Wpds/components/button';

//Selectors
import { getHubspotSignUpUrl } from 'Shared/selectors/smartLinks';

//Logos
import hubspotLogo from 'Shared/images/HubspotLogo.svg';

//Styles
import '../SmartMenu.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';
import { DataSourceSlugs } from 'Shared/constants/types';

const HubspotSmartMenu = props => {
  const { tr } = useTranslation();
  const { hasHubspotIntegration, hubspotSignUpUrl } = props;

  const renderSmartLinkDetailForDeal = (deal, is_last) => {
    const badgeColor = !deal.current_stage.startsWith('Closed')
      ? 'blue'
      : deal.current_stage.includes('Won')
      ? 'green'
      : 'gray';
    return (
      <>
        {deal.name && <div>{tr('perform.smart_links.hubspot.name_label', deal.name)}</div>}
        <div>
          {tr('perform.smart_links.hubspot.current_stage_label')}{' '}
          <WpBadge color={badgeColor} size="md">
            {deal.current_stage}
          </WpBadge>
        </div>
        <div>{tr('perform.smart_links.hubspot.close_date_label', deal.close_date)}</div>
        {!is_last && <p />}
      </>
    );
  };

  const renderSmartLinkDetail = smart_link_detail => {
    const { subtype } = smart_link_detail;
    const capitalizeSubtype = subtype.substr(0, 1).toUpperCase() + subtype.substr(1);
    return (
      <>
        {subtype == 'deal' && renderSmartLinkDetailForDeal(smart_link_detail, true)}
        <p />
        <a href={smart_link_detail.url} target="blank" rel="noopener norefferer">
          {tr('perform.smart_links.hubspot.view_subtype', capitalizeSubtype)}
        </a>
      </>
    );
  };

  const renderSmartLinkBadge = smart_link_detail => {
    const { subtype, current_stage } = smart_link_detail;
    if (subtype != 'deal') return null;
    const badgeColor = !current_stage.startsWith('Closed') ? 'blue' : current_stage.includes('Won') ? 'green' : 'gray';
    return (
      <div>
        <WpBadge color={badgeColor} size="md">
          {current_stage}
        </WpBadge>
      </div>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.hubspot);
    window.location.href = hubspotSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>{tr('perform.smart_links.hubspot.connect_prompt')}</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            {tr('perform.smart_links.hubspot.connect_cta')}
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = smart_link_detail => (
    <>
      <SmartLinkLogo src={hubspotLogo} />{' '}
      {smart_link_detail.subtype == 'deal' && tr('perform.smart_links.hubspot.deal')}
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasHubspotIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      renderSmartLinkBadge={renderSmartLinkBadge}
      objectName={tr('perform.smart_links.hubspot.object_name')}
      menuTitle={menuTitle}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  hasHubspotIntegration: state.organization?.hasHubspotIntegration,
  hubspotSignUpUrl: getHubspotSignUpUrl(state),
});

export default connect(mapStateToProps)(HubspotSmartMenu);
